export default "/static/dashboard/build/app/img/v2/531eae06d53c612f888e68c00bd53235.png";